import { render, staticRenderFns } from "./WEBereich.vue?vue&type=template&id=9c028e50&scoped=true&"
import script from "./WEBereich.vue?vue&type=script&lang=js&"
export * from "./WEBereich.vue?vue&type=script&lang=js&"
import style0 from "./WEBereich.vue?vue&type=style&index=0&id=9c028e50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c028e50",
  null
  
)

export default component.exports